import React, { useEffect } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import './SSORedirect.css';
import { connect } from 'react-redux';
import * as constants from 'constants/App';
import Spinner from 'components/Spinner';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

const SSORedirect = (props) => {
    const location = useLocation();
    const ssoValues = queryString.parse(location.search);

    useEffect(() => {
        if (ssoValues.token !== undefined) {
            props.dispatch({
                type: constants.SSO_USER_SIGNED_IN,
                token: ssoValues.token
            });
        }
    }, []);

    const messages = defineMessages({
        redirect_sso_user: {
            id: 'redirect_sso_user',
            description: 'Redirecting to dashboard...',
            defaultMessage: 'Redirecting to dashboard...'
        },
        signout_sso_user: {
            id: 'signout_sso_user',
            description: 'Thank you...',
            defaultMessage: 'You have been logged out of Holman PartnerConnect. It is now safe to close your browser.'
        }
    });
    return <div>
        <div className="row sso_redirect_redirect_text">
            {
                ssoValues.token !== undefined ?
                <div> 
                    <FormattedMessage {...messages.redirect_sso_user}/> <Spinner /> 
                </div>
                : ssoValues.signed_out !== undefined
                ? <div> <FormattedMessage {...messages.signout_sso_user}/>
                </div>
                : undefined
            }
        </div>
    </div>;
}



function mapStateToProps(state, props) {
    return {
        token: state.appState.getIn(['serverData', 'shared', 'token'])
    };
}

export default connect(mapStateToProps)(SSORedirect);